import React, { useState, useEffect } from "react";
import "./tamperProofWorking.css";
import HowTamperProofWorksBg from "../images/HowTamperProofWorksBg.svg";
import BackgroundLine from "../images/BackgroundLine.svg";

const steps = [
  {
    id: 1,
    title: "Upload Documents",
    label: "Upload Document",
    description:
      "Unlike generic PDF validation tools, TamperProof highlights exact tampered words and edits.",
    imgSrc: "/images/Illustration (24).svg",
    bgcolor: "#001C9F",
    borderColor: "#001C9F33",
  },
  {
    id: 2,
    title: "Detect Every Hidden Change",
    label: "Get Unmatched Insights",
    description:
      "Examining metadata, text, structure, signatures and embedded files to catch even the smallest tampering attempt.",
    imgSrc: "/images/Illustration (27).svg",
    bgcolor: "#8E5AF9",
    borderColor: "#6D2FEC33",
  },
  {
    id: 3,
    title: "Get Unmatched Insights",
    label: "Detect Every Hidden Change",
    description:
      "TamperProof delivers a detailed fraud report with clear evidence of edits, invalid signatures and concealed threats for instant action.",
    imgSrc: "/images/Illustration (25).svg",
    bgcolor: "#94C358",
    borderColor: "#94C35833",
  },
  
];

const TamperProofWorking = () => {
  // const [activeStep, setActiveStep] = useState(0);
  const [wizardIndex, setWizardIndex] = useState(1);
  const [filCircleIndex, setFilCircleIndex] = useState(false);

  // const videoRef = useRef(null);
  // const [isPlaying, setIsPlaying] = useState(false);

  // const handlePlay = () => {
  //   if (videoRef.current) {
  //     videoRef.current.play();
  //     setIsPlaying(true);
  //   }
  // };

  useEffect(() => {
    let timeoutId;

    const interval = setInterval(() => {
      setWizardIndex((prev) => {
        if (prev === 2) {
          setFilCircleIndex(false);
          return 1;
        }

        if (timeoutId) clearTimeout(timeoutId);

        timeoutId = setTimeout(() => {
          setFilCircleIndex(true);
        }, 2700);

        return prev + 1;
      });
    }, 3540);

    return () => {
      clearInterval(interval);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  return (
    <>
      <div className="tamper-curve-section">
        <img src="/images/Rectangle (3).svg" alt="" />
      </div>
      <div
        className="tamperproof-container"
        style={{ backgroundImage: `url(${HowTamperProofWorksBg})` }}
      >
        {/* Background decorative elements */}
        <div className="background-decorations">
          <div className="bg-decoration-1"></div>
          <div className="bg-decoration-2"></div>
          <div className="bg-decoration-3"></div>
        </div>

        <div className="main-content">
          {/* Header */}
          <div className="header">
            <h2 className="title">
              How <span className="title-highlight">TamperProof</span> Works
            </h2>
            <p className="subtitle">
              Three simple steps to validate PDFs and uncover fraud without
              slowing down your workflow.
            </p>
          </div>

          {/* Cards Section - Fixed positions with height animations */}
          <div className="desktop-only">
            <div className="tamper-wizard-statement">
              <div className="tamper-wizard">
                <div className="tamper-step">
                  <div
                    className={`tamper-circle ${
                      wizardIndex === 1 || wizardIndex === 2
                        ? "tamper-circle-active"
                        : ""
                    }`}
                  >
                    1
                  </div>
                  <p className="step-text">Upload Document</p>
                  <div
                    style={{ width: "100%" }}
                    className={`tamper-wizard-line ${
                      wizardIndex === 1 ? "tamper-wizard-line-active" : ""
                    }`}
                  ></div>
                </div>
                <div className="tamper-step">
                  <div
                    className={`tamper-circle ${
                      wizardIndex === 2 ? "tamper-circle-active" : ""
                    }`}
                  >
                    2
                  </div>
                  <p className="tamper-step-text">Detect Every Hidden Change</p>
                  <div
                    className={`tamper-wizard-line ${
                      wizardIndex === 2 ? "tamper-wizard-line-two-active" : ""
                    }`}
                  ></div>
                </div>
                <div className="tamper-step">
                  <div
                    className={`tamper-circle ${
                      filCircleIndex ? "tamper-circle-active" : ""
                    }`}
                  >
                    3
                  </div>
                  <p className="tamper-step-text">Get Unmatched Insights</p>
                </div>
              </div>
            </div>
            <div className="cards-container">
              {steps.map((step, index) => (
                <React.Fragment key={step.id}>
                  <div
                    className={`working-card ${
                      wizardIndex === index + 1
                        ? "active"
                        : index + 1 === 3 && filCircleIndex
                        ? "active"
                        : ""
                    }`}
                    style={{ border: `0.5px solid ${step.borderColor}` }}
                  >
                    {/* image div */}
                    <div
                      className="tamper-working-image"
                      style={{ backgroundColor: `${step.bgcolor}` }}
                    >
                      <img src={step?.imgSrc} alt="" />
                    </div>

                    {/* content div */}
                    <div className="tamper-working-content">
                      <h4>{step.title}</h4>
                      <p>{step.description}</p>
                    </div>
                  </div>

                  {/* Extra image between cards */}
                  {index < steps.length - 1 && (
                    <div className="between-cards-img">
                      <img src={BackgroundLine} alt="separator" />
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>

          {/* Mobile-only fallback image */}
          <div className="mobile-only">
            <img src="/images/Frame (22).svg" alt="Mobile view" />
          </div>

          {/* Video section */}
          {/* <div className="product-preview">
            <video
              ref={videoRef}
              src="/videos/TamperProof Prototype.mp4"
              controls
              autoPlay
              loop
              muted
              className="product-video"
            />
            {!isPlaying && (
              <div className="play-overlay" onClick={handlePlay}>
                <img src="/images/play-circle.svg" alt="" />
              </div>
            )}
          </div> */}
        </div>
      </div>
    </>
  );
};
export default TamperProofWorking;
